import { Box, Button, Heading, Text } from '@flixbus/honeycomb-react';
import { useNavigate } from 'react-router-dom';
import { Icon, IconArrowLeft, IconOffer, IconStar } from '@flixbus/honeycomb-icons-react';
import { Link } from 'react-router-dom';
import { useBatch } from '../../context/VoucherBatchProvider';
import { DownloadBatch } from '../../components/DownloadBatch';

import styles from './batch-status.module.scss';

const BatchProgress = () => {
  const { data } = useBatch();
  const navigate = useNavigate();

  const getCompletionPercentage = (batchSize: number, remainingSize: number): number => {
    if (batchSize === 0) return 100;
    return Math.min(100, Math.max(0, ((batchSize - remainingSize) / batchSize) * 100));
  };

  const percentage = Math.round(getCompletionPercentage(data.batchSize, data.remainingSize));
  const progressValue = data.batchSize - data.remainingSize;
  const createComplete = data.remainingSize === 0;

  return (
    <div className={styles.container}>
      <Button extraClasses={styles.back} Elem='a' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Back to home
      </Button>
      <div className={styles.icon}>
        <flix-illustration name='voucher'></flix-illustration>
      </div>
      <div>
        <Heading flushSpace extraClasses={styles.title} size={1}>
          Your vouchers are being created
        </Heading>
        <Text>You will be able to download them once they are ready!</Text>
      </div>
      <Box small extraClasses={styles.bookmarkBox}>
        <Icon InlineIcon={IconStar} size={6} extraClasses={styles.bookmarkIcon} />
        <Text extraClasses={styles.bookmarkText}>Don&apos;t forget to bookmark the link.</Text>
      </Box>
      <div className={styles.progressContainer}>
        <Text className={styles.text}>{percentage}%</Text>
        <progress className={styles.progress} value={progressValue} max={data.batchSize} />
      </div>
      <div className={styles.actions}>
        <DownloadBatch />
        <Button disabled={!createComplete} appearance='primary' onClick={() => navigate(-1)}>
          <Icon InlineIcon={IconOffer} />
          Create new voucher
        </Button>
      </div>
    </div>
  );
};

export default BatchProgress;
